import { api } from '@services';

interface IInventoryImport {
  docType: 'SpreadSheet' | 'Invoice';
  file: File;
}

const inventoryImport = async ({
  file,
  docType,
}: IInventoryImport): Promise<void> => {
  const formData = new FormData();

  formData.append('file', file);
  formData.append('docType', docType);

  await api.post(`/studios/upload/toImport`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export { inventoryImport };
